import { render, staticRenderFns } from "./DashboardSettingsDrawer.vue?vue&type=template&id=4a210c3a&scoped=true"
import script from "./DashboardSettingsDrawer.vue?vue&type=script&lang=js"
export * from "./DashboardSettingsDrawer.vue?vue&type=script&lang=js"
import style0 from "./DashboardSettingsDrawer.vue?vue&type=style&index=0&id=4a210c3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a210c3a",
  null
  
)

export default component.exports